import { mockData } from "./Mock";
import { EnterpriseAccount, ChangeRecord } from "../../models/EnterpriseAccount";

const mockEnterpriseAccounts: EnterpriseAccount[] = [
    {
        sellerId: 1001,
        sellerNickname: "测试企业1",
        sellerPhone: "13800138001",
        enterpriseName: "北京测试科技有限公司",
        taxNo: "91110105MA7LBXXX1A",
        totalRestMoney: 50000,
        totalChargedMoney: 100000,
        totalWithdrawMoney: 50000,
        withdrawFreezeAmount: 0
    },
    {
        sellerId: 1002,
        sellerNickname: "测试企业2",
        sellerPhone: "13800138002",
        enterpriseName: "上海测试科技有限公司",
        taxNo: "91310105MA7LBXXX2B",
        totalRestMoney: 80000,
        totalChargedMoney: 150000,
        totalWithdrawMoney: 70000,
        withdrawFreezeAmount: 15000
    }
];

const mockChangeRecords: Record<number, ChangeRecord[]> = {
    1001: [
        {
            id: 1,
            type: 1,
            amount: 50000,
            description: "初始充值",
            createTime: new Date("2024-01-01")
        },
        {
            id: 2,
            type: 0,
            amount: -20000,
            description: "提现到企业账户",
            createTime: new Date("2024-01-02")
        },
        {
            id: 3,
            type: 4,
            amount: 5000,
            description: "平台返现-新用户奖励",
            createTime: new Date("2024-01-03")
        }
    ],
    1002: [
        {
            id: 4,
            type: 1,
            amount: 80000,
            description: "初始充值",
            createTime: new Date("2024-01-01")
        },
        {
            id: 5,
            type: 2,
            amount: -30000,
            description: "购买订单#12345",
            createTime: new Date("2024-01-02")
        }
    ]
};

mockData.set("ENTERPRISE_ACCOUNTS", mockEnterpriseAccounts);
mockData.set("CHANGE_RECORDS", mockChangeRecords); 